<!-- <div class="top-nav"> -->
<!-- <mat-toolbar>
      <div class="titleDiv">
        <h2 class="title">Honda</h2>
        <span class="subTitle">The Power of Dreams</span>
      </div> -->

<div>
  <button *ngIf="isAcura" mat-flat-button (click)="onPressAcuraLink()">
    <span>AcuraLink</span>
  </button>
  
  <button *ngIf="!isAcura" mat-flat-button (click)="onPressHondaLink()">
    <span>HondaLink</span>
  </button>

  <button mat-flat-button (click)="onPressOwners()">
    <span>MyGarage</span>
  </button>
  <button mat-flat-button (click)="onPressFaqs()">
    <span>FAQ</span>
  </button>
  <button mat-flat-button (click)="onPressmyAccount()">
    <span>My Account</span>
  </button>
  <button mat-flat-button (click)="onPressSignOut()" class="background-red-color">
    <span>Sign Out</span>
  </button>
</div>
<!-- </mat-toolbar> -->
<!-- </div> -->